import Papa from "papaparse";
import ExcelJS from "exceljs";

export function computationHelper(aggregatedData = {}, objects = []) {
  const completed = objects?.filter((obj) => obj.status === "C");
  const voided = objects?.filter((obj) => obj.status === "V");

  const transactionTypes = Object.values(aggregatedData).flatMap((storeData) =>
    Object.keys(storeData),
  );

  const uniqueTransactionTypes = [...new Set(transactionTypes)];

  const totals = completed.reduce(
    (acc, o) => {
      const t = Number(o.total) || 0;
      acc.gross += t;
      acc.discount += Number(o.discount_amount) || 0;
      acc.pretax += Number(o.total_pretax) || 0;
      acc.tax += Number(o.total_tax) || 0;
      acc.taxFree += Number(o.total_taxfree) || 0;
      acc.net += t - (Number(o.total_tax) || 0);
      return acc;
    },
    { gross: 0, discount: 0, pretax: 0, tax: 0, taxFree: 0, net: 0 },
  );

  const voidTotals = voided.reduce(
    (acc, o) => {
      acc.amount += Number(o.total) || 0;
      return acc;
    },
    { amount: 0 },
  );
  const voidCount = voided.length;

  const sortedStores = Object.keys(aggregatedData || {}).sort();

  return {
    totals,
    // uniqueTransactionTypes,
    voidTotals: { amount: voidTotals.amount, count: voidCount },
    // sortedStores,
  };
}

// /**
//  * @param {Object} params
//  * @param {Object} params.aggregatedData  – same shape as in your state
//  * @param {Array}  params.objects         – full objects array from state
//  * @param {string} params.startDate       – formatted start date
//  * @param {string} params.endDate         – formatted end date
//  */
// export function exportReportCSV({
//   aggregatedData = {},
//   objects = [],
//   startDate = "",
//   endDate = "",
// }) {
//   const filtered = objects.filter((obj) => obj.status === "C");

//   const allTransactionTypes = [
//     "Delivery",
//     "Dine In",
//     "Take Out",
//     "GrabFood",
//     "FoodPanda",
//     "Pick Up",
//     "Del Time",
//     "Drive-thru",
//     "Tablevibe",
//     "undefined",
//   ];

//   const summaryTotals = filtered.reduce(
//     (acc, o) => {
//       const t = Number(o.total) || 0;
//       acc.gross += t;
//       acc.discount += Number(o.discount_amount) || 0;
//       acc.pretax += Number(o.total_pretax) || 0;
//       acc.tax += Number(o.total_tax) || 0;
//       acc.taxFree += Number(o.total_taxfree) || 0;
//       return acc;
//     },
//     { gross: 0, discount: 0, pretax: 0, tax: 0, taxFree: 0 }
//   );

//   summaryTotals.net = summaryTotals.gross - summaryTotals.tax;

//   const dataRows = Object.keys(aggregatedData).map((store) => {
//     const storeData = aggregatedData[store] || {};
//     const row = { Store: store };

//     const totalNet = allTransactionTypes.reduce(
//       (sum, type) => sum + (storeData[type]?.netSale || 0),
//       0
//     );
//     const totalCount = allTransactionTypes.reduce(
//       (sum, type) => sum + (storeData[type]?.tc || 0),
//       0
//     );

//     allTransactionTypes.forEach((type) => {
//       const { netSale = 0, tc = 0 } = storeData[type] || {};
//       const percentage =
//         totalNet > 0 ? ((netSale / totalNet) * 100).toFixed(2) : "0.00";

//       row[`${type} Net Sale`] = netSale;
//       row[`${type} TC`] = tc;
//       row[`${type} Percentage`] = percentage;
//     });

//     row["Total Net Sale"] = totalNet;
//     row["Total Count"] = totalCount;
//     return row;
//   });

//   dataRows.push({
//     Store: "Summary Totals",
//     "Gross Sales": summaryTotals.gross,
//     "Total Discount Amount": summaryTotals.discount,
//     "Total Pretax": summaryTotals.pretax,
//     "Total Tax": summaryTotals.tax,
//     "Total Tax Free": summaryTotals.taxFree,
//     "Net Sales": summaryTotals.net,
//   });

//   const csvHeaders = [
//     "Store",
//     ...allTransactionTypes.flatMap((type) => [
//       `${type} Net Sale`,
//       `${type} TC`,
//       `${type} Percentage`,
//     ]),
//     "Total Net Sale",
//     "Total Count",
//     "Gross Sales",
//     "Total Discount Amount",
//     "Total Pretax",
//     "Total Tax",
//     "Total Tax Free",
//     "Net Sales",
//   ];

//   const csv = Papa.unparse({ fields: csvHeaders, data: dataRows });

//   const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//   const link = document.createElement("a");
//   link.href = URL.createObjectURL(blob);
//   link.setAttribute("download", `report-${startDate}-to-${endDate}.csv`);
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// }

export async function exportReportCSV({
  aggregatedData = {},
  objects = [],
  startDate = "",
  endDate = "",
}) {
  const filtered = objects.filter((obj) => obj.status === "C");

  const allTransactionTypes = [
    "Delivery",
    "Dine In",
    "Take Out",
    "GrabFood",
    "FoodPanda",
    "Pick Up",
    "Del Time",
    "Drive-thru",
    "Tablevibe",
    "undefined",
  ];

  const summaryTotals = filtered.reduce(
    (acc, o) => {
      const t = Number(o.total) || 0;
      acc.gross += t;
      acc.discount += Number(o.discount_amount) || 0;
      acc.pretax += Number(o.total_pretax) || 0;
      acc.tax += Number(o.total_tax) || 0;
      acc.taxFree += Number(o.total_taxfree) || 0;
      return acc;
    },
    { gross: 0, discount: 0, pretax: 0, tax: 0, taxFree: 0 },
  );

  summaryTotals.net = summaryTotals.gross - summaryTotals.tax;

  // Create workbook
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Figaro BI Analytics";
  workbook.created = new Date();

  // ========== SHEET 1: Transaction Type Analysis ==========
  const sheet1 = workbook.addWorksheet("Transaction Analysis", {
    views: [{ state: "frozen", xSplit: 1, ySplit: 4 }],
  });

  // Title
  sheet1.mergeCells("A1:E1");
  const titleCell = sheet1.getCell("A1");
  titleCell.value = "Sales Report by Transaction Type";
  titleCell.font = {
    name: "Inter",
    size: 16,
    bold: true,
    color: { argb: "FF1F4D2C" },
  };
  titleCell.alignment = { vertical: "middle", horizontal: "left" };
  sheet1.getRow(1).height = 30;

  // Date Range
  sheet1.mergeCells("A2:E2");
  const dateCell = sheet1.getCell("A2");
  dateCell.value = `Period: ${startDate} to ${endDate}`;
  dateCell.font = {
    name: "Inter",
    size: 11,
    italic: true,
    color: { argb: "FF666666" },
  };
  dateCell.alignment = { vertical: "middle", horizontal: "left" };
  sheet1.getRow(2).height = 20;

  // Empty row
  sheet1.getRow(3).height = 10;

  // Headers
  const headerRow = sheet1.getRow(4);
  let colIndex = 1;

  // Store column
  headerRow.getCell(colIndex++).value = "Store";

  // Transaction type columns
  allTransactionTypes.forEach((type) => {
    headerRow.getCell(colIndex++).value = `${type}\nNet Sale`;
    headerRow.getCell(colIndex++).value = `${type}\nTC`;
    headerRow.getCell(colIndex++).value = `${type}\n%`;
  });

  // Total columns
  headerRow.getCell(colIndex++).value = "Total\nNet Sale";
  headerRow.getCell(colIndex++).value = "Total\nCount";

  // Style header row
  headerRow.height = 40;
  headerRow.eachCell((cell) => {
    cell.font = {
      name: "Inter",
      bold: true,
      color: { argb: "FFFFFFFF" },
      size: 10,
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF1F4D2C" },
    };
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };
    cell.border = {
      top: { style: "thin", color: { argb: "FF000000" } },
      left: { style: "thin", color: { argb: "FF000000" } },
      bottom: { style: "thin", color: { argb: "FF000000" } },
      right: { style: "thin", color: { argb: "FF000000" } },
    };
  });

  // Data Rows
  let rowIndex = 5;
  Object.keys(aggregatedData).forEach((store, idx) => {
    const storeData = aggregatedData[store] || {};
    const row = sheet1.getRow(rowIndex++);

    const totalNet = allTransactionTypes.reduce(
      (sum, type) => sum + (storeData[type]?.netSale || 0),
      0,
    );
    const totalCount = allTransactionTypes.reduce(
      (sum, type) => sum + (storeData[type]?.tc || 0),
      0,
    );

    let cellIndex = 1;

    // Store name
    const storeCell = row.getCell(cellIndex++);
    storeCell.value = store;
    storeCell.font = { name: "Inter", bold: true, size: 10 };
    storeCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: idx % 2 === 0 ? "FFF3F4F6" : "FFFFFFFF" },
    };
    storeCell.alignment = { vertical: "middle", horizontal: "left" };

    // Transaction data
    allTransactionTypes.forEach((type) => {
      const { netSale = 0, tc = 0 } = storeData[type] || {};
      const percentage = totalNet > 0 ? (netSale / totalNet) * 100 : 0;
      const bgColor = idx % 2 === 0 ? "FFF3F4F6" : "FFFFFFFF";

      // Net Sale
      const netSaleCell = row.getCell(cellIndex++);
      netSaleCell.value = netSale;
      netSaleCell.numFmt = "#,##0.00";
      netSaleCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: bgColor },
      };
      netSaleCell.alignment = { vertical: "middle", horizontal: "right" };
      netSaleCell.font = { name: "Inter", size: 9 };

      // TC
      const tcCell = row.getCell(cellIndex++);
      tcCell.value = tc;
      tcCell.numFmt = "#,##0";
      tcCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: bgColor },
      };
      tcCell.alignment = { vertical: "middle", horizontal: "center" };
      tcCell.font = { name: "Inter", size: 9 };

      // Percentage
      const percentCell = row.getCell(cellIndex++);
      percentCell.value = percentage / 100;
      percentCell.numFmt = "0.00%";
      percentCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: bgColor },
      };
      percentCell.alignment = { vertical: "middle", horizontal: "center" };
      percentCell.font = {
        name: "Inter",
        size: 9,
        color: { argb: percentage > 20 ? "FF16A34A" : "FF666666" },
        bold: percentage > 20,
      };
    });

    // Total Net Sale
    const totalNetCell = row.getCell(cellIndex++);
    totalNetCell.value = totalNet;
    totalNetCell.numFmt = "#,##0.00";
    totalNetCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE0F2FE" },
    };
    totalNetCell.alignment = { vertical: "middle", horizontal: "right" };
    totalNetCell.font = { name: "Inter", bold: true, size: 10 };

    // Total Count
    const totalCountCell = row.getCell(cellIndex++);
    totalCountCell.value = totalCount;
    totalCountCell.numFmt = "#,##0";
    totalCountCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE0F2FE" },
    };
    totalCountCell.alignment = { vertical: "middle", horizontal: "center" };
    totalCountCell.font = { name: "Inter", bold: true, size: 10 };

    row.height = 20;
  });

  // Grand Total Row
  rowIndex++; // Empty row
  const grandTotalRow = sheet1.getRow(rowIndex++);
  grandTotalRow.height = 30;

  const grandTotal = Object.values(aggregatedData).reduce((sum, storeData) => {
    return (
      sum +
      allTransactionTypes.reduce(
        (storeSum, type) => storeSum + (storeData[type]?.netSale || 0),
        0,
      )
    );
  }, 0);

  const grandCount = Object.values(aggregatedData).reduce((sum, storeData) => {
    return (
      sum +
      allTransactionTypes.reduce(
        (storeSum, type) => storeSum + (storeData[type]?.tc || 0),
        0,
      )
    );
  }, 0);

  // Merge cells for grand total label
  const lastCol = 1 + allTransactionTypes.length * 3;
  sheet1.mergeCells(rowIndex - 1, 1, rowIndex - 1, lastCol);
  const grandTotalLabelCell = sheet1.getCell(rowIndex - 1, 1);
  grandTotalLabelCell.value = "GRAND TOTALS";
  grandTotalLabelCell.font = {
    name: "Inter",
    bold: true,
    size: 12,
    color: { argb: "FFFFFFFF" },
  };
  grandTotalLabelCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF83C14A" },
  };
  grandTotalLabelCell.alignment = { vertical: "middle", horizontal: "center" };

  // Grand total values
  const grandTotalNetCell = grandTotalRow.getCell(lastCol + 1);
  grandTotalNetCell.value = grandTotal;
  grandTotalNetCell.numFmt = "#,##0.00";
  grandTotalNetCell.font = {
    name: "Inter",
    bold: true,
    size: 12,
    color: { argb: "FFFFFFFF" },
  };
  grandTotalNetCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF83C14A" },
  };
  grandTotalNetCell.alignment = { vertical: "middle", horizontal: "right" };

  const grandTotalCountCell = grandTotalRow.getCell(lastCol + 2);
  grandTotalCountCell.value = grandCount;
  grandTotalCountCell.numFmt = "#,##0";
  grandTotalCountCell.font = {
    name: "Inter",
    bold: true,
    size: 12,
    color: { argb: "FFFFFFFF" },
  };
  grandTotalCountCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF83C14A" },
  };
  grandTotalCountCell.alignment = { vertical: "middle", horizontal: "center" };

  // Set column widths
  sheet1.getColumn(1).width = 25; // Store
  for (let i = 0; i < allTransactionTypes.length; i++) {
    sheet1.getColumn(2 + i * 3).width = 15; // Net Sale
    sheet1.getColumn(3 + i * 3).width = 10; // TC
    sheet1.getColumn(4 + i * 3).width = 10; // Percentage
  }
  sheet1.getColumn(lastCol + 1).width = 18; // Total Net Sale
  sheet1.getColumn(lastCol + 2).width = 12; // Total Count

  // ========== SHEET 2: Financial Summary ==========
  const sheet2 = workbook.addWorksheet("Financial Summary");

  // Title
  sheet2.mergeCells("A1:B1");
  const summaryTitleCell = sheet2.getCell("A1");
  summaryTitleCell.value = "Financial Summary";
  summaryTitleCell.font = {
    name: "Inter",
    size: 16,
    bold: true,
    color: { argb: "FF1F4D2C" },
  };
  summaryTitleCell.alignment = { vertical: "middle", horizontal: "left" };
  sheet2.getRow(1).height = 30;

  // Date Range
  sheet2.mergeCells("A2:B2");
  const summaryDateCell = sheet2.getCell("A2");
  summaryDateCell.value = `Period: ${startDate} to ${endDate}`;
  summaryDateCell.font = {
    name: "Inter",
    size: 11,
    italic: true,
    color: { argb: "FF666666" },
  };
  summaryDateCell.alignment = { vertical: "middle", horizontal: "left" };
  sheet2.getRow(2).height = 20;

  // Empty row
  sheet2.getRow(3).height = 10;

  // Headers
  const summaryHeaderRow = sheet2.getRow(4);
  summaryHeaderRow.height = 30;
  summaryHeaderRow.getCell(1).value = "Description";
  summaryHeaderRow.getCell(2).value = "Amount";

  summaryHeaderRow.eachCell((cell) => {
    cell.font = {
      name: "Inter",
      bold: true,
      color: { argb: "FFFFFFFF" },
      size: 11,
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF1F4D2C" },
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Summary data
  const summaryItems = [
    {
      label: "Gross Sales",
      value: summaryTotals.gross,
      color: "FFDBEAFE",
      icon: "💰",
    },
    {
      label: "Total Discount Amount",
      value: summaryTotals.discount,
      color: "FFFEE2E2",
      icon: "🏷️",
    },
    {
      label: "Total Pretax",
      value: summaryTotals.pretax,
      color: "FFF3F4F6",
      icon: "📊",
    },
    {
      label: "Total Tax",
      value: summaryTotals.tax,
      color: "FFFEF3C7",
      icon: "📈",
    },
    {
      label: "Total Tax Free",
      value: summaryTotals.taxFree,
      color: "FFF3F4F6",
      icon: "✅",
    },
    {
      label: "Net Sales",
      value: summaryTotals.net,
      color: "FFD1FAE5",
      icon: "💵",
      bold: true,
    },
  ];

  let summaryRowIndex = 5;
  summaryItems.forEach((item) => {
    const row = sheet2.getRow(summaryRowIndex++);
    row.height = 25;

    const labelCell = row.getCell(1);
    labelCell.value = `${item.icon} ${item.label}`;
    labelCell.font = {
      name: "Inter",
      bold: item.bold || false,
      size: 11,
    };
    labelCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: item.color },
    };
    labelCell.alignment = { vertical: "middle", horizontal: "left" };
    labelCell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    const valueCell = row.getCell(2);
    valueCell.value = item.value;
    valueCell.numFmt = "#,##0.00";
    valueCell.font = {
      name: "Inter",
      bold: item.bold || false,
      size: 11,
    };
    valueCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: item.color },
    };
    valueCell.alignment = { vertical: "middle", horizontal: "right" };
    valueCell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Set column widths for summary
  sheet2.getColumn(1).width = 35;
  sheet2.getColumn(2).width = 20;

  // Generate and download file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `Sales_Report_${startDate}_to_${endDate}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
